export default {
  // About
  about_badge: '// About Company',
  about_title1: 'RHEINMETALL AG —',
  about_title2: 'LEADER OF EUROPEAN',
  about_title3: 'DEFENSE',
  about_desc1: 'Founded in 1889, Rheinmetall AG is Germany\'s largest defense conglomerate and one of the world\'s leading manufacturers of military equipment and ammunition. Headquarters in Düsseldorf, Germany.',
  about_desc2: 'Amid sharp growth in NATO and European defense budgets, Rheinmetall is posting record financial results. The order backlog has exceeded <strong>€50 billion</strong> — guaranteed production capacity through 2030 and stable returns for investors.',
  about_tags: 'Armored Vehicles,Artillery,Ammunition,Electronics,Cybersecurity',
  about_img_caption: 'Order backlog through 2030',
  about_stat1: 'Founded',
  about_stat2: 'Revenue 2024',
  about_stat3: 'Employees',
  about_stat4: 'Partner Countries',

  // Weapons
  weapons_badge: '// Military Equipment',
  weapons_title1: 'NEXT-GENERATION',
  weapons_title2: 'WEAPONRY',
  weapons_subtitle: 'Full production cycle from ammunition to armored vehicles. Deliveries to 50+ countries. Every contract is your profit.',
  weapons_specs_label: 'Specifications',
  weapons_hide: 'Hide',
  weapons_show: 'Specifications',
  w1_title: 'Main Battle Tanks', w1_desc: 'World\'s best main battle tank. Leopard 2A8 features Trophy active protection, latest fire control system and 120mm Rh-120 smoothbore gun. Orders from 12 NATO countries.', w1_tag: 'Armor', w1_rev: '€8.2B orders',
  w2_title: 'Self-Propelled Howitzer', w2_desc: 'World\'s most accurate self-propelled artillery. Range up to 67km with guided shells. Used by Germany, Netherlands, Greece, Italy and Ukraine.', w2_tag: 'Artillery', w2_rev: '€3.5B orders',
  w3_title: 'Infantry Fighting Vehicle', w3_desc: 'Next-generation IFV with modular architecture. Armed with 35mm Wotan autocannon and Spike LR2 ATGMs. Contracts with Hungary, Australia, Slovakia.', w3_tag: 'IFV', w3_rev: '€5.1B orders',
  w4_title: 'Air Defense System', w4_desc: 'Revolutionary air defense system against drones, helicopters and low-flying aircraft. 30mm cannon at 1200 rds/min. Integrates on any platform.', w4_tag: 'Air Defense', w4_rev: '€2.8B orders',
  w5_title: '155mm Ammunition', w5_desc: 'Rheinmetall — Europe\'s largest artillery ammunition manufacturer. 155mm shell production increased 8x. Contracts with 20+ NATO countries for millions of rounds.', w5_tag: 'Ammunition', w5_rev: '€4.7B orders',
  w6_title: 'Gepard AA Tank', w6_desc: 'Legendary self-propelled AA gun with twin 35mm cannons. Proven effective against drones and cruise missiles in real combat. Deliveries to Ukraine were a turning point.', w6_tag: 'SPAAG', w6_rev: '€1.9B orders',

  // Conflicts
  conflicts_badge: '// Conflict Zones',
  conflicts_title1: 'CRITICAL ROLE IN',
  conflicts_title2: 'GLOBAL SECURITY',
  conflicts_subtitle: 'Rheinmetall supplies equipment to hotspots and conflict zones. Every shot is your income. War is business, and we invite you to be part of it.',
  conflicts_deliveries: 'Deliveries',
  conflicts_hide: 'Hide',
  conflicts_more: 'Details',
  conflicts_why_label: 'Why it\'s profitable',
  conflicts_why_title: 'WAR IS STOCK GROWTH',
  conflicts_why_desc: 'NATO defense budgets grew by <strong>+40% in 2 years</strong>. Germany increased military spending to €100B. Poland spends 4% of GDP on defense. Every conflict means new contracts for Rheinmetall and new profits for investors.',
  stat_stocks: 'Stock growth in 3 years',
  stat_backlog: 'Order backlog',
  stat_ammo: 'Ammo production growth',
  c1_region: 'Ukraine', c1_status: 'Active', c1_desc: 'Largest buyer of Rheinmetall equipment. Hundreds of Leopard 2, Marder, Gepard units delivered. Joint armored vehicle factory opened in Ukraine.',
  c2_region: 'Poland', c2_status: 'Contract signed', c2_desc: 'Poland is implementing the largest rearmament program in its history. 800 K2 tanks with Rheinmetall turrets, 500 Lynx KF41 IFVs ordered.',
  c3_region: 'Germany', c3_status: 'Long-term', c3_desc: 'Bundeswehr conducting large-scale modernization. 18 PzH 2000, 123 Leopard 2A8, 143 Lynx KF41 ordered. Defense budget grew to €100B — all-time record.',
  c4_region: 'Hungary', c4_status: 'Production', c4_desc: 'Hungary is building a Rheinmetall factory on its territory. 218 Lynx KF41 ordered — largest IFV contract in European history.',
  c5_region: 'Australia', c5_status: 'New contract', c5_desc: 'Australia chose Lynx KF41 to replace aging M113s. Contract for 450 vehicles with local production. Rheinmetall opens factory in Queensland.',
  c6_region: 'Romania', c6_status: 'Negotiations', c6_desc: 'Romania plans to purchase 300 Lynx KF41 and 54 PzH 2000. Country borders Ukraine and is actively building military capacity with NATO support.',

  // Calculator
  calc_badge: '// Profit Calculator',
  calc_title1: 'CALCULATE',
  calc_title2: 'YOUR PROFIT',
  calc_subtitle: 'Transparent yield system with no hidden fees. All deals close in 3 days.',
  calc_plan1: 'Starter',
  calc_plan2: 'Optimal',
  calc_plan3: 'Premium',
  calc_popular: 'Popular',
  calc_per_year: '%',
  calc_custom_label: 'Custom amount (€)',
  calc_custom_placeholder: 'Min. €',
  calc_period_label: 'Deal period: 3 days',
  calc_period_months: '',
  calc_profit_label: 'Your profit in 3 days',
  calc_profit_months: '',
  calc_total_label: 'Total amount: ',
  calc_invested: 'Invested',
  calc_rate: 'Rate',
  calc_per_yr: '%',
  calc_cta: 'Open Investment Account',
  calc_feat1_title: 'Deposit Insurance',
  calc_feat1_desc: 'Your funds are protected by the European deposit insurance system',
  calc_feat2_title: 'Quarterly Payouts',
  calc_feat2_desc: 'Receive profits every 3 months to your account',
  calc_feat3_title: 'Legal Protection',
  calc_feat3_desc: 'Contract under German law, notarized',

  // Contact
  contact_badge: '// Contact',
  contact_title1: 'START',
  contact_title2: 'INVESTING TODAY',
  contact_subtitle: 'Leave a request and our manager will contact you within 24 hours to open an investment account.',
  contact_why_title: 'Why choose us',
  contact_r1_title: 'Licensed Broker', contact_r1_desc: 'Regulated by BaFin (Germany) and FCA (UK)',
  contact_r2_title: 'Fund Security', contact_r2_desc: 'Funds held in segregated accounts at Deutsche Bank',
  contact_r3_title: 'Personal Manager', contact_r3_desc: 'Individual support throughout the investment period',
  contact_r4_title: 'Fast Start', contact_r4_desc: 'Account opened in 24 hours, first payouts in 3 months',
  contact_address_label: 'Address',
  contact_form_title: 'Investment Application',
  contact_name_label: 'Your Name *',
  contact_name_placeholder: 'John Smith',
  contact_email_label: 'Email *',
  contact_phone_label: 'Phone',
  contact_phone_placeholder: '+1 999 000 0000',
  contact_amount_label: 'Investment Amount',
  contact_amount_placeholder: 'Choose a plan',
  contact_amount_opt1: '€3,000 — 24%',
  contact_amount_opt2: '€5,000 — 29%',
  contact_amount_opt3: '€10,000 — 37%',
  contact_amount_opt4: 'Custom amount',
  contact_msg_label: 'Message',
  contact_msg_placeholder: 'Your questions or requests...',
  contact_submit: 'Send Request',
  contact_sending: 'Sending...',
  contact_success: 'Request sent! We will contact you within 24 hours.',
  contact_error: 'Send error. Please try again or contact us directly.',
  contact_privacy: 'By clicking the button, you agree to the privacy policy',

  // Footer
  footer_desc: 'Rheinmetall AG Investment Portal. Invest in the leader of the European defense industry.',
  footer_company: 'Company',
  footer_investors: 'Investors',
  footer_products: 'Products',
  footer_about: 'About',
  footer_history: 'History',
  footer_production: 'Production',
  footer_news: 'News',
  footer_plans: 'Plans',
  footer_calculator: 'Calculator',
  footer_docs: 'Documents',
  footer_faq: 'FAQ',
  footer_armor: 'Armored Vehicles',
  footer_artillery: 'Artillery',
  footer_ammo: 'Ammunition',
  footer_air: 'Air Defense',
  footer_rights: '© 2025 Rheinmetall Investment Portal. All rights reserved.',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
  footer_disclaimer: 'Investing involves risks. Past performance does not guarantee future returns. This site is for informational purposes only and does not constitute a public offer.',

  // EarningsToast
  toast_earned: 'earned on contract',
  toast_period: 'in 3 days',

  // Navigation
  nav: {
    about: 'About',
    weapons: 'Weapons',
    conflicts: 'Conflicts',
    calculator: 'Calculator',
    contact: 'Contact',
  },

  // Hero Section
  hero: {
    badge: 'Open for Investors',
    title1: 'INVESTMENTS',
    title2: 'IN THE FUTURE',
    title3: 'OF DEFENSE',
    description: 'Rheinmetall AG — Europe\'s largest defense conglomerate. Invest from €3,000 and earn up to {{return}} in 3 days.',
    stat1: 'Returns up to 37% in 3 days',
    stat2: 'Contracts worth €50+ billion until 2030',
    stat3: 'Stock growth +280% over 3 years',
    cta1: 'Calculate Returns',
    cta2: 'Learn More',
    scroll: 'Scroll Down',
    turretLabel: 'Leopard 2A7+',
    turretHint: 'Turret · Click to Fire',
  },

  // About Section
  about: {
    label: 'About Company',
    title: 'RHEINMETALL AG',
    subtitle: 'Europe\'s Defense Leader',
    description: 'German industrial conglomerate, world leader in armored vehicles and artillery systems. Since the war in Ukraine began, the company has increased production by 400%.',
    stats: {
      founded: 'Founded',
      employees: 'Employees',
      revenue: 'Revenue',
      contracts: 'Order Backlog',
    },
  },

  // Weapons Section
  weapons: {
    label: 'Military Equipment',
    title: 'COMBAT SYSTEMS',
    subtitle: 'Modern armored vehicles and artillery that form the backbone of NATO forces',
    items: {
      leopard: {
        name: 'Leopard 2A7+',
        desc: 'Main battle tank — the flagship of European armored forces',
      },
      lynx: {
        name: 'Lynx KF41',
        desc: 'Next-generation infantry fighting vehicle',
      },
      puma: {
        name: 'PUMA',
        desc: 'Heavy infantry fighting vehicle',
      },
      panzerhaubitze: {
        name: 'Panzerhaubitze 2000',
        desc: 'Self-propelled howitzer with 40km range',
      },
      fuchs: {
        name: 'Fuchs',
        desc: 'Armored personnel carrier',
      },
      boxer: {
        name: 'Boxer',
        desc: 'Modular armored vehicle',
      },
    },
  },

  // Conflicts Section
  conflicts: {
    label: 'Geopolitics',
    title: 'CONFLICT ZONES',
    subtitle: 'Current military conflicts driving defense industry growth',
    ukraine: {
      title: 'War in Ukraine',
      description: 'Since 2022, Rheinmetall has supplied over 200 Leopard tanks and established local production. Contracts worth €8.5 billion.',
    },
    middleEast: {
      title: 'Middle East',
      description: 'Supply of air defense systems and armored vehicles to Qatar, UAE, and Saudi Arabia. Contracts worth €12 billion.',
    },
    baltic: {
      title: 'Baltic Region',
      description: 'NATO reinforcement program. New production facilities in Lithuania and Romania. Investments of €2.5 billion.',
    },
  },

  // Calculator Section
  calculator: {
    label: 'Investment Calculator',
    title: 'CALCULATE YOUR RETURNS',
    subtitle: 'Calculate potential returns from investing in Rheinmetall AG shares',
    amount: 'Investment Amount',
    period: 'Investment Period',
    years: '{{years}} years',
    result: 'Projected Returns',
    total: 'Total Amount',
    profit: 'Net Profit',
    cta: 'Start Investing',
  },

  // Contact Section
  contact: {
    label: 'Contact Us',
    title: 'GET IN TOUCH',
    subtitle: 'Our investment advisors are ready to answer your questions',
    form: {
      name: 'Your Name',
      email: 'Email',
      phone: 'Phone',
      amount: 'Investment Amount',
      message: 'Message',
      submit: 'Send Request',
      success: 'Thank you! We will contact you soon.',
    },
  },

  // Testimonials
  testimonials: {
    badge: '// Investor Reviews',
    title1: 'WHAT OUR',
    title2: 'INVESTORS SAY',
    subtitle: 'Real results from real investors across Europe. No faces — just numbers.',
    from: 'from',
    stat1: 'Active Investors',
    stat2: 'Total Paid Out',
    stat3: 'Max Return',
    stat4: 'Countries',
    t1: {
      name: 'M. Krause',
      role: 'Private investor · Frankfurt',
      text: 'I was skeptical at first — defense investments seemed too niche. But after the first deal closed in 3 days with 37% return, I doubled my position. Rheinmetall is not just a company, it\'s a machine that prints money in wartime.',
    },
    t2: {
      name: 'И. Димитров',
      role: 'Entrepreneur · Sofia',
      text: 'Tried many platforms — crypto, forex, real estate. Nothing compares to the stability here. Three deals, three wins. The manager explained everything clearly, the contract is in German law. I sleep well.',
    },
    t3: {
      name: 'P. Wiśniewski',
      role: 'Engineer · Warsaw',
      text: 'Poland is rearming at record pace — I decided to profit from it. Invested €12,000, got back €16,440 in 3 days. Now I\'m telling all my colleagues. This is the most logical investment of our time.',
    },
    t4: {
      name: 'L. Russo',
      role: 'Business owner · Milan',
      text: 'In Italy we say: invest where the money flows. And money flows into defense right now. I put in €20,000 and got €27,400 back. The process was smooth, transparent, professional. Highly recommend.',
    },
    t5: {
      name: 'E. Hansen',
      role: 'Financial analyst · Oslo',
      text: 'As an analyst I track defense stocks daily. Rheinmetall\'s fundamentals are exceptional — €50B backlog, NATO tailwinds, record margins. This investment portal gives retail access to institutional-grade returns.',
    },
  },

  // Footer
  footer: {
    rights: '© {{year}} Rheinmetall AG. All rights reserved.',
    disclaimer: 'Investment in securities involves risks. Past performance does not guarantee future results.',
  },
};
